import React from 'react';
import classNames from 'classnames';

import css from './AverageStarRating.module.css';

const RATING_STAR_COUNT = 5;

const StarIcon = ({ className, fillRatio = 1 }) => {
  const clipId = `star-clip-${Math.random().toString(36).slice(2, 9)}`;
  return (
    <svg className={className} width="14" height="13" viewBox="0 0 14 13" aria-hidden="true">
      <defs>
        <clipPath id={clipId}>
          <rect x="0" y="0" width={14 * fillRatio} height="13" />
        </clipPath>
      </defs>
      <path
        d="M7 0.5l1.7 3.45 3.8.55-2.75 2.7.65 3.8L7 9.2 3.6 11l.65-3.8L1.5 4.5l3.8-.55z"
        fill="#e5e5e8"
      />
      <path
        d="M7 0.5l1.7 3.45 3.8.55-2.75 2.7.65 3.8L7 9.2 3.6 11l.65-3.8L1.5 4.5l3.8-.55z"
        fill="currentColor"
        clipPath={`url(#${clipId})`}
      />
    </svg>
  );
};

/**
 * Render five star icons, each partially filled to represent an average
 * rating (e.g. 4.8 → 4 full + one 80%-filled star). The unfilled portion
 * uses a muted base path so empty stars remain visible.
 *
 * @param {Object} props
 * @param {string} [props.rootClassName] - overrides the default root class
 * @param {string} [props.className] - extends the default root class
 * @param {number} props.rating - average rating (0–5)
 * @returns {JSX.Element}
 */
const AverageStarRating = props => {
  const { className, rootClassName, rating = 0 } = props;
  const classes = classNames(rootClassName || css.stars, className);

  const stars = [];
  for (let i = 0; i < RATING_STAR_COUNT; i += 1) {
    const fill = Math.max(0, Math.min(1, rating - i));
    stars.push(<StarIcon key={i} className={css.starIcon} fillRatio={fill} />);
  }
  return <span className={classes}>{stars}</span>;
};

export default AverageStarRating;
